import React, { useEffect, useState } from 'react';
import { Bar } from "react-chartjs-2";
import {
 Chart,
 CategoryScale,
 LinearScale,
 BarElement,
 Tooltip,
 Legend,
} from "chart.js";

Chart.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const PromotionAgeDistribution = ({ r_data }) => {
 const [pageData, setPageData] = useState([]);

 useEffect(() => {
  setPageData(r_data || []);
 }, [r_data]);

 const labels = pageData.map(item => item.age_group);
 const values = pageData.map(item => item.count);

 const total = values.reduce((a, b) => a + b, 0);

 const data = {
  labels,
  datasets: [
   {
    label: "Participants",
    data: values,
    backgroundColor: "rgba(102, 126, 234, 0.7)",
    borderRadius: 6,
    barThickness: 30
   }
  ]
 };

 return (
  <div style={{
   background: "#fff",
   borderRadius: "10px",
   padding: "16px"
  }}>

   {/* Header */}
   <div style={{ marginBottom: "12px" }}>
    <h6 style={{ marginBottom: "4px", fontWeight: 600 }}>
     Age Distribution
    </h6>

    <small style={{ color: "#6c757d" }}>
     Total participants: <strong>{total}</strong>
    </small>
   </div>

   {/* Chart */}
   <div style={{ height: "260px" }}>
    <Bar
     data={data}
     options={{
      indexAxis: "y", // makes it horizontal (important)
      maintainAspectRatio: false,
      plugins: {
       legend: { display: false },
       tooltip: {
        callbacks: {
         label: (ctx) => `${ctx.parsed.x} participants`
        }
       }
      },
      scales: {
       x: {
        beginAtZero: true,
        ticks: { color: "#6c757d", font: { size: 11 } },
        grid: { color: "rgba(0,0,0,0.05)" }
       },
       y: {
        ticks: { color: "#6c757d", font: { size: 12 } },
        grid: { display: false }
       }
      }
     }}
    />
   </div>
  </div>
 );
};

export default PromotionAgeDistribution;